export default {
    modalShowImageVariations: {
        imageAi: 'Kuvatunnistus-älykkyys',
        regenerateImage: 'Tuota uutta sisältöä',
        description: 'Kuvaus',
        style: 'Tyyli',
        saveToLibrary: 'Tallenna kirjastoon',
        continue: 'Jatka',
        cancel: 'Peruuttaa',
        select: 'Valitse',
        copy: 'Kopioi',
        selectedImage: 'Valittu kuva',
        saved: 'pelastettu',
        variations: 'Muunnelmat',
    },
};
